/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespSimilarItemTileCarousel_item = {
    readonly serviceId: string | null;
    readonly seller: {
        readonly serviceId: string | null;
    } | null;
    readonly " $refType": "PdpRespSimilarItemTileCarousel_item";
};
export type PdpRespSimilarItemTileCarousel_item$data = PdpRespSimilarItemTileCarousel_item;
export type PdpRespSimilarItemTileCarousel_item$key = {
    readonly " $data"?: PdpRespSimilarItemTileCarousel_item$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSimilarItemTileCarousel_item">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSimilarItemTileCarousel_item",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Seller",
      "kind": "LinkedField",
      "name": "seller",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};
})();
(node as any).hash = '2755d9fcebcdb0e27db5597d37ba4f56';
export default node;
